
import * as ACTIONS from '../constants';



//export function getInfodex(payload) {
  
  //return {
    //type: ACTIONS.CRYODEX_INFODEX_GET, payload };
  
//};  

//export function getAllInfodexes() {
  //return {
    //type: ACTIONS.CRYODEX_INFODEX_ALL_GET
  //}
//};
  
export function updateInfodex(payload) {
  return { type: ACTIONS.CRYODEX_INFODEX_UPDATE, payload };
};

export function updateInfodexCryodexLink(payload){
  return { type: ACTIONS.CRYODEX_CRYODEX_INFODEX_LINK_UPDATE, payload };
}

export function unlinkInfodexLinked(payload) {

  return { type: ACTIONS.CRYODEX_CRYODEX_INFODEX_UNLINK, payload };
};

export function updateInfodexes(payload) {
  return { type: ACTIONS.CRYODEX_INFODEX_UPDATE, payload };
};

export function updateStatus(payload){
  return { type: ACTIONS.CRYODEX_INFODEX_LINKED_STATUS_UPDATE, payload};
}

export function mapInfodexRelationShip(payload) {
  return { type: ACTIONS.CRYODEX_USER_GROUPS_MAP_RELATIONSHIP, payload };
};

export function getInfodexGroups(payload) {
  return { type: ACTIONS.CRYODEX_INFODEX_GROUPS_GET, payload };
}

export function getCryodexLinks(){
  return { type: ACTIONS.CRYODEX_CRYODEX_LINKS_GET };  
}

export function getInfodexLinked(payload){
  
  return { type: ACTIONS.CRYODEX_INFODEX_LINKED_GET ,payload};  
}


export function updateInfodexLinked(payload){
  return { type: ACTIONS.CRYODEX_INFODEX_LINKED_UPDATE ,payload};  
}